import { en } from './messages/en'
import { vi } from './messages/vi'
import { generatedEn } from './messages/generated-en'
import { generatedVi } from './messages/generated-vi'
import type { Locale } from './config'

export type Messages = typeof en
export type MessageKey = keyof Messages

const catalogs: Record<Locale, Record<string, string>> = { en: { ...generatedEn, ...en }, vi: { ...generatedVi, ...vi } }

export type Translate = (key: MessageKey, values?: Record<string, string | number>) => string

/** Pure translator: falls back to English, then to the key itself, and fills `{name}` placeholders. */
export function createTranslator(locale: Locale): Translate {
  return (key, values) => {
    const template = catalogs[locale][key] ?? catalogs.en[key] ?? key
    return values
      ? template.replace(/\{(\w+)\}/g, (_, name: string) => String(values[name] ?? `{${name}}`))
      : template
  }
}

/**
 * Label lookup for dynamic names (collections, fields, options). `null` when untranslated so the
 * caller can fall back to a humanized name and new collections keep working without a dictionary entry.
 */
export function lookup(locale: Locale, key: string): string | null {
  return catalogs[locale][key] ?? null
}
